import React from "react";
import { McqQuestion } from "./McqQuestion";
import {
  CHANNELS, COMM_TONES, DAYS, HOUR_SLOTS, MONTHLY_TARGETS,
  COMMON_OBJECTIONS, OBJECTION_ANSWERS, SALES_ACTIONS,
} from "./constants";

const TONES_OPTIONS = COMM_TONES.map((t) => ({ v: t.v, label: `${t.v} — ${t.desc}` }));
const DAYS_OPTIONS = DAYS.map(([v, label]) => ({ v, label }));

/** Step 4 — Stratégie & canaux (10 MCQ) */
export function StepStrategy({ form, up }) {
  return (
    <div className="space-y-5">
      <div className="rounded-xl px-5 py-4 border border-emerald-500/30 bg-emerald-500/10">
        <p className="hp-label mb-1" style={{ color: "#86efac" }}>
          10 questions · environ 3 min
        </p>
        <p className="text-sm text-zinc-300 leading-relaxed">
          Calibrons ensemble le rythme et le ton de vos campagnes.
        </p>
      </div>

      <McqQuestion
        title="1. Quel est votre canal principal de prospection ?"
        mode="single"
        options={CHANNELS}
        value={form.preferred_channel}
        onChange={(v) => up("preferred_channel", v)}
        testidPrefix="q-channel"
      />
      <McqQuestion
        title="2. Quels canaux secondaires utilisez-vous ?"
        subtitle="Prosperr adaptera ses messages à chaque canal."
        mode="multi"
        options={CHANNELS.filter((c) => c.v !== "Mix")}
        value={form.secondary_channels}
        onChange={(v) => up("secondary_channels", v)}
        testidPrefix="q-channel-sec"
      />
      <McqQuestion
        title="3. Quel ton adoptez-vous avec vos prospects ?"
        mode="single"
        options={TONES_OPTIONS}
        value={form.communication_tone}
        onChange={(v) => up("communication_tone", v)}
        testidPrefix="q-tone"
        columns={1}
      />
      <McqQuestion
        title="4. Quels jours prospectez-vous ?"
        mode="multi"
        options={DAYS_OPTIONS}
        value={form.prospecting_days}
        onChange={(v) => up("prospecting_days", v)}
        testidPrefix="q-day"
      />
      <McqQuestion
        title="5. Quel créneau horaire privilégiez-vous ?"
        mode="single"
        options={HOUR_SLOTS}
        value={form.prospecting_hours}
        onChange={(v) => up("prospecting_hours", v)}
        testidPrefix="q-hour"
        columns={1}
      />
      <McqQuestion
        title="6. Quel objectif mensuel visez-vous ?"
        mode="single"
        options={MONTHLY_TARGETS}
        value={form.monthly_target}
        onChange={(v) => up("monthly_target", v)}
        testidPrefix="q-target"
        columns={1}
      />
      <McqQuestion
        title="7. Vos 2 objections les plus fréquentes ?"
        subtitle="Prosperr générera des réponses sur-mesure."
        mode="multi"
        maxSelect={2}
        options={COMMON_OBJECTIONS}
        value={form.common_objections}
        onChange={(v) => up("common_objections", v)}
        testidPrefix="q-obj"
      />
      <McqQuestion
        title="8. Vos 2 meilleures techniques de réponse ?"
        mode="multi"
        maxSelect={2}
        options={OBJECTION_ANSWERS}
        value={form.objection_answers}
        onChange={(v) => up("objection_answers", v)}
        testidPrefix="q-ans"
      />
      <McqQuestion
        title="9. Quelle action commerciale maîtrisez-vous le mieux ?"
        mode="single"
        options={SALES_ACTIONS}
        value={form.best_action}
        onChange={(v) => up("best_action", v)}
        testidPrefix="q-best-action"
      />
      <McqQuestion
        title="10. Quelle action commerciale vous coûte le plus ?"
        subtitle="Prosperr vous aidera à progresser dessus."
        mode="single"
        options={SALES_ACTIONS}
        value={form.hardest_action}
        onChange={(v) => up("hardest_action", v)}
        testidPrefix="q-hardest-action"
      />
    </div>
  );
}
